import { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useSelector } from "react-redux";
import { toast } from 'react-toastify';
import { apiHandler } from "../../assets/api";
import { endpoint } from "../../assets/api/endpoint";
import CustomButton from '../../components/CustomButton';
import '../../assets/css/PlayerProfile.css';
import Spinner from '../../components/Spinner';
import { IoIosArrowBack } from "react-icons/io";
import playerImage from '../../assets/images/badmintonplayerphoto.png';
import dummyImage from '../../assets/images/dummy-banner.jpg';
import smallPlayerImage from '../../assets/images/PlayerImage.png';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import boyImage from '../../assets/images/boy.png';
import { HashLoader } from 'react-spinners';
import { IoIosArrowDropleft } from "react-icons/io";
import Boy from '../../assets/icons/B.png';
import Girl from '../../assets/icons/G.png';


const PlayerProfile = () => {
    const { accessToken } = useSelector((state) => state.loginInfo);
    const navigate = useNavigate();
    const location = useLocation();
    const [playerData, setPlayerData] = useState(null);
    const stringerPlayer = location.state?.stringerPlayers;
    const disabledButton = location.state?.disabledButton;
    const userId = location.state?.id;
    const game = [{ gameName: 'tennis', sportId: 1 }, { gameName: 'pickerBall', sportId: 1 }]
    const uniqueStringerPlayer = stringerPlayer?.filter((item) => item.id == userId);
    const sportName = uniqueStringerPlayer?.[0]?.sportProfiles?.[0]?.sport;
    const filteredGames = game?.filter(g => g?.gameName?.toLowerCase() === sportName?.toLowerCase());
    const sportId = filteredGames?.length > 0 ? filteredGames[0]?.sportId : null;
    const [isChecked, setIsChecked] = useState(playerData?.stringer);
    const [loader, setLoader] = useState(false);
    const [userProfileResponse, setuserProfileResponse] = useState();
    const dummyImages = [
        dummyImage,
        dummyImage,
        dummyImage,
        dummyImage,
    ];

    const imagesToShow = playerData?.images?.image?.length > 0 ? playerData.images.image : dummyImages;

    useEffect(() => {
        const fetchPlayerData = async () => {
            try {
                const response = await apiHandler({
                    url: `${endpoint?.STRINGER_PROFILE_DETAIL}?id=${userId}`,
                    method: "GET",
                    authToken: accessToken?.accessToken,
                });
                if (response?.data?.data) {
                    setPlayerData(response?.data?.baseProfile);
                    setuserProfileResponse(response?.data?.userProfileResponse);
                } else {
                    toast.error(response?.data?.error_description || "Failed to fetch player data");
                }
            } catch (error) {
                toast.error("Something went wrong. Please try again.");
            }
        };
        fetchPlayerData();
    }, [accessToken.accessToken]);

    useEffect(() => {
        if (imagesToShow.length > 0) {
            const carouselEl = document.querySelector('#carouselExampleSlidesOnly');
            if (carouselEl && window.bootstrap?.Carousel) {
                const carouselInstance = window.bootstrap.Carousel.getInstance(carouselEl);
                if (carouselInstance) {
                    carouselInstance.dispose(); // Destroy previous instance
                }
                new window.bootstrap.Carousel(carouselEl, {
                    interval: 4000,
                    ride: 'carousel',
                });
            }
        }
    }, [imagesToShow]);
    const onExclude = async () => {
        setLoader(true)
        try {
            const response = await apiHandler({
                url: `${endpoint?.EXCLUDE_USER}?userId=${userId}&sportId=${sportId}`,
                method: "POST",
                authToken: accessToken?.accessToken,
            });
            if (response?.data && !response?.data?.error_description) {
                toast.success(response?.data?.message);
                navigate(-1)
            } else {
                toast.error(response?.data?.user_description);

            }
        } catch (error) {
            setLoader(false);
            toast.error("Something Went Wrong Please Try Again")
        }
        setTimeout(() => setLoader(false), 6000);

    }

    const onFavourite = async () => {
        setLoader(true);
        try {
            const response = await apiHandler({
                url: `${endpoint?.MOVE_IN_PREFERABLE_LIST}?userId=${userId}&sportId=${sportId}`,
                method: "POST",
                authToken: accessToken?.accessToken,
            });
            if (response?.data && !response?.data?.error_description) {
                toast.success(response?.data?.message)
                navigate(-1)
            } else {
                toast.error(response?.data?.user_description)
            }
        } catch (error) {
            toast.error("Something Went Wrong Please Try Again")
        }
        setTimeout(() => setLoader(false), 6000);
    }
    const onGoToBackPage = () => {
        navigate(-1);
    }

    if (!playerData) return <div className="d-flex align-items-center justify-content-center" style={{ height: '75vh' }}>
        < HashLoader color="#e48181" />
    </div>

    return (
        <div className='d-flex justify-content-center align-items-center mt-3'>
            <div className='container player-profile-wrapper'>
                <div className='row  pt-3 pb-2 pb-3 px-3'>
                    <div className='' >
                        <div className="d-flex justify-content-start" >
                            <CustomButton
                                className="back-page-btn"
                                onClick={onGoToBackPage}
                                buttonText={
                                    <> <IoIosArrowDropleft className="me-3" style={{ cursor: 'pointer', fontSize: '31px' }} /> Back</>
                                }
                            />
                        </div>
                        <div
                            id="carouselExampleSlidesOnly"
                            className="carousel slide "
                            data-bs-ride="carousel"
                            data-bs-interval="1000"
                        >
                            <div className="carousel-inner">
                                {imagesToShow?.map((imgSrc, index) => (
                                    <div key={index} className={`carousel-item ${index === 0 ? 'active' : ''}`}>
                                        <img
                                            style={{ height: '400px' }}
                                            src={`${endpoint.BASE_URL_STAGING}/public/images/${imgSrc}`}
                                            className="d-block w-100"
                                            alt={`slide-${index}`}
                                            onError={(e) => {
                                                e.target.onerror = null;
                                                e.target.src = dummyImage;
                                            }}
                                        />
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                    <div className='d-sm-flex mt-4' style={{ gap: '24px' }} >
                        <div className=' flex-fill bg-white ps-3 pt-3 pe-sm-4 pb-3 ps-sm-4' style={{ boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)', borderRadius: '10px' }} >
                            <div className='py-3'>
                                <div className='d-flex'>
                                    <img src={playerData?.avatarUrl || boyImage} alt="Avatar" width="100" height="100" />
                                    <div style={{ height: '100px', width: '15px', backgroundColor: '#e9ecef', borderRadius: '0px', overflow: 'hidden' }}>
                                        <div
                                            style={{
                                                height: `${playerData?.reliabilityNum}%`,
                                                width: '100%',
                                                backgroundColor: 'green',
                                                transition: 'height 0.3s ease',
                                            }}
                                        ></div>
                                    </div>
                                </div>
                                <div className="fw-normal pt-3" style={{ fontSize: '16px', color: '#71727A' }}>
                                    {playerData?.avatarName || 'Unknown Player'}
                                </div>

                            </div>
                            <div className='d-flex justify-content-between'>
                                <div>
                                    <div className='player-pro-name'>
                                        {playerData?.name} <span className='player-age-level'>{playerData?.age}  <span style={{ color: 'rgb(113, 114, 122)', fontSize: '14px' }}>({userProfileResponse[0]?.skillLevel})</span> <span style={{ color: 'rgb(113, 114, 122)', fontSize: '14px' }} >{playerData?.gender ? `(${playerData?.gender})` : ''} </span></span>
                                        <img src={playerData?.gender == "MALE" ? Boy : Girl} width='20px' height='20px' />
                                    </div>
                                    <div className='mt-2'> {playerData?.distance ? (playerData.distance / 1609.34).toFixed(2) + ' miles' : ''} </div>
                                    <div className='player-age-level py-2'>{playerData?.city}, {playerData?.state}</div>
                                </div>
                            </div>
                            <div className='hash-tag-tennis py-2'>{playerData?.note}</div>
                        </div>
                        <div className=' flex-fill bg-white mt-3 mt-sm-0 p-2 pt-3 pe-sm-4 pb-3 ps-sm-4' style={{ boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)', borderRadius: '10px' }}>
                            <div className='fav-court'>Fav Court: <span className='fav-court-val'>{playerData?.preferrableCourt || 'nothing'}</span></div>
                            <div className='py-2 player-preferable-time'>Preferable Time: <span className='player-preferable-time-val'>{playerData?.preferredTime || 'nothing'}</span></div>
                            <div className='d-flex justify-content-between py-3'><div>
                                <CustomButton buttonText={'Exclude'} className='border find-player-exclude-btn' onClick={() => onExclude()} disabled={disabledButton == "exludedUser" || loader} /></div>
                                <div><CustomButton buttonText={'Favourate'} onClick={() => onFavourite()} className='border find-player-favourate-btn' disabled={disabledButton == 'preferredUser' || loader} /></div></div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PlayerProfile;
